import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/branches/BranchesAction";
import * as uiHelpers from "../BranchesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useBranchesUIContext } from "../BranchesUIContext";

export function BranchesTable({ 
  deleteBranches
}) {
  // Branches UI Context
  const branchesUIContext = useBranchesUIContext();
  const branchesUIProps = useMemo(() => {
    return {
      ids: branchesUIContext.ids,
      setIds: branchesUIContext.setIds,
      queryParams: branchesUIContext.queryParams,
      setQueryParams: branchesUIContext.setQueryParams,
      openEditBranchPage: branchesUIContext.openEditBranchPage
    };
  }, [branchesUIContext]);

  // Getting curret state of Branches list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.branches }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Branches Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getBranches(branchesUIProps.queryParams));
    return () => dispatch(actions.cleanBranchesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditBranchPage: branchesUIProps.openEditBranchPage,
      deleteBranches
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: branchesUIProps.queryParams.pageSize,
    page: branchesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                branchesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: branchesUIProps.ids,
                setIds: branchesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}